import { useCallback, useEffect, useRef } from "react";
import { NEWRELIC_TABLES, recordNREvent } from "@swiggy-private/checkout-core";

const useCelebrationSound = (soundUrl: string) => {
    const audioRef = useRef<HTMLAudioElement | null>(null);
    const isUnmountedRef = useRef(false);

    useEffect(() => {
        if (!soundUrl) return;

        isUnmountedRef.current = false;

        const audio = new Audio(soundUrl);
        audio.preload = "auto";
        audioRef.current = audio;

        return () => {
            isUnmountedRef.current = true;
            audio.pause();
            audioRef.current = null;
        };
    }, [soundUrl]);

    const playSound = useCallback(() => {
        const audio = audioRef.current;
        if (!audio || isUnmountedRef.current) return;

        audio
            .play()
            .then(() => {
                recordNREvent({
                    eventType: NEWRELIC_TABLES.TABLE_RESERVATION_CELEBRATION_SOUND_PLAYED,
                    readyState: audio.readyState,
                });
            })
            .catch((error: unknown) => {
                recordNREvent({
                    eventType: NEWRELIC_TABLES.TABLE_RESERVATION_CELEBRATION_SOUND_NOT_READY,
                    errorMessage: error instanceof Error ? error.message : String(error),
                    errorName: error instanceof Error ? error.name : "",
                    readyState: audio.readyState,
                });
            });
    }, []);

    return { playSound };
};

export default useCelebrationSound;
